export const VENDORS_SELECTION_FOOTER_REVIEW_AND_PAY_BUTTON_ID = 'vendors-selection-footer-review-and-pay-button';
